import { getApiUrl } from './apiUrls';
import HTTPGetClient from './HTTPClient';
import environment from './environment';

export const API = new HTTPGetClient({ baseUrl: getApiUrl(2) });
export const API_WWW = new HTTPGetClient({ baseUrl: getApiUrl(1) });
export const API_URL = new HTTPGetClient({ baseUrl: '' });
export const API_ASSETS = new HTTPGetClient({
  baseUrl: `${environment.isLocal ? '' : '/reacttools'}/assets/`
});
